// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import {MenuItem, DropdownButton} from 'ui'
import TranscriptMenuItem from './TranscriptMenuItem';
import { useProjectUsers } from 'hooks/users/queries';
import UrlUtil from 'utils/UrlUtil';

import {
  TRANSCRIPT_TITLE,
  DEMOGRAPHICS_TITLE,
  CODED_BY_ME_TITLE,
  COMPARISON_TITLE,
} from 'constants/TranscriptNavigationConstants'

function TranscriptDropdown(props) {
  const { data: projectUsers, isLoading } = useProjectUsers(props.projectID);
  const {collaborators, owner} = projectUsers || {};

  const showGotoCodedByMe = !isLoading && collaborators && collaborators.length > 0;
  
  const handleGotoCompare = () => {
    const ownerId = owner?.id;
    const page = props.page;
    let collaboratorId = (collaborators?.[0] || {}).id;

    collaboratorId = !collaboratorId && isLoading ? 'none' : collaboratorId;

    const url = UrlUtil.addParamsToUrl(
      `/transcripts/${props.transcriptID}/compare`,
      {
        ...(ownerId && {left: ownerId}),
        ...(collaboratorId && {right: collaboratorId}),
        ...(page && page > 1 && {page: page}),
      }
    )

    props.gotoCompare(url);
  };

  return (
    <DropdownButton
    title={props.title}
    id={`transcript-navigation-dropdown`}
    variant='white'
  >
    <MenuItem
      onClick={()=>{props.onNavigationClick(null)}}
      eventKey="1">
        <TranscriptMenuItem
          description="See transcript and codes."
        >
          {TRANSCRIPT_TITLE}
        </TranscriptMenuItem>
    </MenuItem>
    <MenuItem divider />
    {showGotoCodedByMe && <MenuItem
      onClick={props.gotoCodedByMe}    
      eventKey="2"
    >
      <TranscriptMenuItem
        description="Hide how other people coded.">
        {CODED_BY_ME_TITLE}
      </TranscriptMenuItem>
    </MenuItem>
    }
    {showGotoCodedByMe && <MenuItem divider />}
    <MenuItem
      eventKey="3"
      onClick={handleGotoCompare}>
      <TranscriptMenuItem
        description="Compare how people coded.">
        {COMPARISON_TITLE}
      </TranscriptMenuItem>
    </MenuItem>

    <MenuItem divider />
    <MenuItem
      eventKey="4"
      onClick={props.gotoDemographics}>
      <TranscriptMenuItem
        description="Assign descriptors to transcripts."
        marginBottom="5px">
      {DEMOGRAPHICS_TITLE}
    </TranscriptMenuItem>
    </MenuItem>
  </DropdownButton>
  )

}

export default TranscriptDropdown;
